import LanguageDropdown from "components/Language/LanguageDropdown"
import React, { Component,useEffect , Fragment} from "react"
import { Link, withRouter } from "react-router-dom"
import {Button, Icon, Message, Modal, Form,Checkbox,Dropdown,TextArea, Image, Menu} from "semantic-ui-react"
import {
	Card,
	Col,
	Container,
	FormField,
	FormInput,
	Row,
  } from "elemental-react16"
  import MenuBySlug from "components/Menu/MenuBySlug"
  import Responsive from "react-responsive"
  import app from "app.controller"
import queryString from "qs"
import shop from "shop/shop"
import FormCMS from "components/Form/FormCMS"
import WordPressContainer from "WordPressContainer"
import languageStore from "stores/languageStore"

@withRouter
export default class NewCustomerContactPage extends Component {

	state = {
			activeStep: 0,
			form1Disabled: false,
			form2Disabled: true,
			form3Disabled: true,
			form4Disabled: true,
			form5Disabled: true,
			form1Check: false,
			form2Check: false,
			form4Check: false,
			newcust: {
				firm: {
					name: "",
					customernumber: "",
					uidnr: "",
					glnnr: "",
					legalForm: "",
					taxNumber: "",
					branche: "",
				},
				person: {
					salutation: "",
					firstname: "",
					lastname: "",
					position: "",
				},
				address: {
					street: "",
					streetnumber: "",
					addition: "",
					postcode: "",
					city: "",
					country: "",
					deliverstreet: "",
					deliverstreetnumber: "",
					deliveraddition: "",
					deliverpostcode: "",
					delivercity: "",
					delivercountry: ""
				},
			contact: {
				customernumber: shop.session ? shop.session.value.map_id : "",
				content: "",
				locale: "de",
				email: "",
				nachname: "",
				subject: "",
				vorname: "",
			},
				locale: ""
			}
		}


	handleSendCustReg = async (newCustomer, closeModal) =>{
		console.log("contact: ", this.state.newcust, closeModal)
		if(closeModal){
			await this.handleSetModalConfig()
		}
		const { currentLanguage } = languageStore
		newCustomer.locale = currentLanguage

		if(this.state.newcust.contact.customernumber == "" || this.state.newcust.contact.email == "" || this.state.newcust.contact.content == "" || this.state.newcust.contact.vorname == "" || this.state.newcust.contact.nachname == "" || this.state.newcust.contact.subject == ""){
			shop.toast(translate("Bitte alle Pflichtfelder ausfüllen!"))
			console.log("contact: ", this.state.newcust, closeModal)
			return
		}

		try {
		await shop.fetch( `/shop/rest/service/request?id=customer_contact`, {
			method: "POST",
			body: JSON.stringify( this.state.newcust.contact ),
		} )
		shop.toast( "Kontaktanfrage erfolgreich verschickt!" )
		console.log("newcust: ", this.state.newcust)
		const delay = ms => new Promise(
			resolve => setTimeout(resolve, ms)
		  );
		  this.props.onCloseModal()
		//await delay(2000);
		//this.props.history.push("/home");
		}
		catch (err) {
		console.log( err )
		shop.toast( err )
		}
	}

	handleSetModalConfig = async () => {
		if(this.props.closeModal && this.state.newcust.contact.content !== " "){
			this.setState(prevState => ({
				newcust: {
					...prevState.newcust,
					contact: {
						...prevState.newcust.contact,
						content: " "
					}
				}
			}));
		}
		if(this.props.closeModal && this.state.newcust.contact.subject == ""){
			this.setState(prevState => ({
				newcust: {
					...prevState.newcust,
					contact: {
						...prevState.newcust.contact,
						subject: "Anfrage senden"
					}
				}
			}));
		}
	}
	
	render() {
		const countryOptions = [
			{ key: 'de', value: 'de', flag: 'de', text: 'Deutschland' },
			{ key: 'x', value: 'x', flag: 'x', text: 'Andere' },
		  ]
		  const { currentLanguage } = languageStore
		  let genderOptions =[ ]
		  if(currentLanguage == 'fr'){
			genderOptions = [
				{ key: 'male', value: 'Herr', text: 'Monsieur' },
				{ key: 'female', value: 'Frau', text: 'Madame' },
			]
		  }
		  else{
			genderOptions = [
				{ key: 'male', value: 'Herr', text: 'Herr' },
				{ key: 'female', value: 'Frau', text: 'Frau' },
				{ key: 'diverse', value: 'Divers', text: 'Divers' },
			]
		  }

		  let referefenceOptions = [ ]
		 if(currentLanguage == 'en'){
			referefenceOptions = [
				{ key: 'male', value: 'Kontaktdaten ändern', text: 'Kontaktdaten ändern' },
				{ key: 'female', value: 'Preisanfrage', text: 'Preisanfrage' },
				{ key: 'female', value: 'Bitte um Kontaktaufnahme', text: 'Bitte um Kontaktaufnahme' },
				{ key: 'female', value: 'Bitte um technische Unterstützung', text: 'Bitte um technische Unterstützung' },
				{ key: 'diverse', value: 'Sonstiges', text: 'Sonstiges' },
			]
		  }
		  else{
			if (!this.props.closeModal) {
				referefenceOptions = [
					{ key: 'male', value: 'Termin vereinbaren', text: 'Termin vereinbaren' },
					{ key: 'male', value: 'Kontaktdaten ändern', text: 'Kontaktdaten ändern' },
					{ key: 'female', value: 'Preisanfrage', text: 'Preisanfrage' },
					{ key: 'female', value: 'Bitte um Kontaktaufnahme', text: 'Bitte um Kontaktaufnahme' },
					{ key: 'female', value: 'Bitte um technische Unterstützung', text: 'Bitte um technische Unterstützung' },
					{ key: 'diverse', value: 'Sonstiges', text: 'Sonstiges' },
					
				]
			}
			else{
				referefenceOptions = [
					{ key: 'diverse', value: 'Anfrage senden', text: 'Anfrage senden' }
					
				]
			}
		  }


		  const handleChange = (event) => {
			console.log("CHANGE: ", event.target)
			let tempname = event.target.name
			let tempname2 = event.target.className
			let tempvalue = event.target.value
			this.setState(prevState => {
				let newcust = { ...prevState.newcust };  
				newcust[tempname][tempname2] = tempvalue;       
				return { newcust }; 
			  })
		  };  
		  const handleDropDownChange = (event, {value}) => {
			let tempvalue = value
			this.setState(prevState => {
				let newcust = { ...prevState.newcust };  
				newcust.contact.subject = tempvalue;
				return { newcust }; 
			  })
		  }; 
		
		 const handleCommentChange = ( event ) => {
			console.log("VALUE:",event.target)
			let content = event.target.value
			this.setState(prevState => {
				let newcust = { ...prevState.newcust };  
				newcust.contact.content = content;       
				return { newcust }; 
			  })
		  }
		const { activeStep } = this.state 
		const query = queryString.parse( this.props.location.search.substr( 1 ) )
		const { overlay } = query
		const { history } = this.props

		if (!this._captcha) {
			const a = Math.floor(Math.random() * 9) + 1
			const b = Math.floor(Math.random() * 9) + 1
			this._captcha = { q: `${a} + ${b} = ?`, a: String(a + b) }
		}
		const solved = this.state.captchaInput === this._captcha.a

		console.log("this.props: ", this.props)
		return (
			<Fragment >
				<div className="backgroundImageBannerShop" ></div>
				<div className="FilterPageHeader">
				<Container style={{paddingTop: '2vh'}}>
				{/*<div className="pa3">
					<div className="fr"> <LanguageDropdown/></div>
					<Button as={Link} to="/login"><Icon name="chevron left"/>{translate( "back to login" )}</Button>
				</div>*/}

						
						</Container>
						</div>
				<Container className="pt5 pb5">
							<div className="flex flex-row justify-start pt3 pb3" >
							  <div className="pb3" >
								<Link className={"logo"} to="/home/">
								  <img
									src={"/Logo_JohannesLucht_gruen.png"} width={500}
									alt="" />
								</Link>
								</div>
							<div className="pb3 pl2">
							   <table>
								<colgroup>
								  <col width="50%"/>
								  <col width="50%"/>
								</colgroup>
								<tbody>
								  <tr>
									<td colSpan="2" className="pt4 pa2">
									{/*<p className="f4 fw7">{translate("Vertriebsinnendienst")}</p> */}
									</td>
									</tr>
								  <tr>
									<td className="pt3 pa2" style={{ minWidth: "170px" }}>
									{/*                      <a href={`tel:+49407392040`}><span className="f5 fw5" style={{ color: "#369678", backgroundColor: "transparent" }}><Icon
												name={"phone"} />+49-40-739204-0 </span></a> */}
									  </td>
									<td className="pt3 pa2" style={{ minWidth: "170px" }}>
										{/*                      <a href={`mailto:shop@herenz.de?subject=Anfrage bezüglich des Bestellvorgangs, Kunde #${shop.session.value.map_id}`}>
										<span className="f5 fw5" style={{ color: "#369678", backgroundColor: "transparent" }}><Icon
									  name={"mail"} />shop@herenz.de</span></a> */}
									</td>
								  </tr>
								</tbody>
							  </table>
							  </div>
							</div>
				{<Form style={{backgroundColor: "#f3f0e7", borderRadius: "10px"}}>
					<div style={{minHeight: "300px", display: "flex", flexDirection: "column", justifyContent: "center"}}>
						{this.props.closeModal && <Form.Group  className="w-100 pt2 pb2" widths="equal" style={{alignItems: "center", display: "flex"}}>
							<Form.Input required label={translate("Kundennummer")} style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
								<input id="default" fluid value={this.state.newcust.contact.customernumber} onChange={handleChange} className="customernumber" name="contact" label="Kundennummer:" placeholder={translate("Kundennummer")} style={{verticalAlign: "middle"}} />
							</Form.Input>
						</Form.Group>}
						<Form.Group  className="w-100 pt2 pb2" widths="equal" style={{alignItems: "center", display: "flex"}}>
							<Form.Input required label={translate("Vorname")} style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
								<input id="default" fluid value={this.state.newcust.person.vorname} onChange={handleChange} className="vorname" test="firstname" name="contact" label="Vorname:" placeholder={translate("Vorname")} style={{verticalAlign: "middle"}} />
							</Form.Input>
							<Form.Input required label={translate("Nachname")} style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
								<input id="default" fluid value={this.state.newcust.person.nachname} onChange={handleChange} className="nachname" name="contact" label="Nachname:" placeholder={translate("Nachname")} style={{verticalAlign: "middle"}} />
							</Form.Input>
						</Form.Group>
						<Form.Group className="w-100 pt2 pb2"  widths="equal" style={{alignItems: "center", display: "flex"}}>
							<Form.Input  required className="default" label={translate("E-Mail")} style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
								<input id="default" style={{backgroundColor: "#ffffff", verticalAlign: "middle"}} value={this.state.newcust.contact.email} onChange={handleChange} className="email" name="contact" nameadd="email" placeholder={translate("E-Mail")} />
							</Form.Input>
							<Form.Input required label={translate("Telefon")} style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
								<input id="default" value={this.state.newcust.contact.phone} onChange={handleChange} required fluid className="phone" name="contact" label="Telefon:" placeholder={translate("Telefon")} style={{verticalAlign: "middle"}} />
							</Form.Input>
						</Form.Group>
						{!this.props.closeModal && <Form.Field className="w-100 pt2 pb2" required style={{backgroundColor: "#f3f0e7", height: "50px", display: "flex", flexDirection: "column", justifyContent: "center"}}>
							<label>{translate("Betreff")}</label>
							<Dropdown
								id="default"
								fluid
								floating
								style={{backgroundColor: "#ffffff", height: "50px", minHeight: "50px", display: "flex", alignItems: "center"}}
								value={this.state.newcust.person.reference}
								onChange={handleDropDownChange}
								clearable
								label="Land:"
								className="reference"
								name="contact"
								required
								selection  defaultValue={ referefenceOptions[0].value}
								options={referefenceOptions}
								placeholder={translate("Betreff")}
							/>
						</Form.Field>}
						{!this.props.closeModal && <FormField  className="w-100 pt2 pb2" label={<label className="fw6 f5 black-90">{translate("Ihre Mitteilung an uns")}</label>} htmlFor="supported-controls-input" style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
							<FormInput placeholder={translate("Ihr Kommentar...")} className="deliveryComment" value={this.state.newcust.contact.comment} onChange={handleCommentChange} multiline style={{verticalAlign: "middle"}} />
						</FormField>}
						<Checkbox className="pt3 pb3"  label={<label className="fw6 f7"><p className="f7 fw7">{translate(`Ja, ich habe die Datenschutzerklärung zur Kenntnis genommen und bin damit einverstanden, dass die von mir angegebenen Daten elektronisch erhoben und gespeichert werden.`)}</p></label>} />
						{<div className="pb5">
							<div className="pb3" style={{ display: "flex", alignItems: "center"}}>
								<span style={{ marginRight: 8, fontWeight: 600 }}>{this._captcha.q}</span>
								<input
									value={this.state.captchaInput || ""}
									onChange={e => this.setState({ captchaInput: e.target.value })}
									style={{
										width: 56,
										marginRight: 8,
										padding: "6px 8px",
										borderRadius: 4,
										border: "1px solid #ccc"
									}}
									placeholder="?"
								/>
								<Icon
									name="refresh"
									link
									onClick={() => {
										const a = Math.floor(Math.random() * 9) + 1
										const b = Math.floor(Math.random() * 9) + 1
										this._captcha = { q: `${a} + ${b} = ?`, a: String(a + b) }
										this.setState({ captchaInput: "" })
									}}
								/>
								{solved && <Icon name="check" color="green" style={{ marginLeft: 6 }} />}
							</div>
							<Button style={{
								borderRadius: "35px", 
								height: "50px", 
								width: "250px", 
								color: "white",
								transition: "all 0.3s ease",
								padding: "10px 20px 10px 20px",
								
							}} disabled={!solved} onClick={() => this.handleSendCustReg(this.state.newcust, this.props.closeModal)} primary>

						{this.props.closeModal ? translate("Zugang anfordern") : translate("Anfrage abschicken")}
						<i className="icon-angle-right"/>
						</Button></div>}
					</div>
				</Form>}
				</Container>
			</Fragment>
		)
	}
}




// WEBPACK FOOTER //
// ./src/theme/lucht-test/pages/NewCustomerContactPage.js